import React, { useState, useEffect } from "react";
import ClimateChangeModel from "../ModelLayouts/ClimateChangeModel";
import ClimateChangePopup from "../../components/PopUps/ClimateChangePopup";
import { Link } from "react-router-dom";
import Icon from "../ui/Icon";
import CareSector from "../DetailsSubSections/ClimateChange/CareSector";
import CareCrisis from "../DetailsSubSections/ClimateChange/CareCrisis";
import EnvironmentalRelations from "../DetailsSubSections/ClimateChange/EnvironmentalRelations";
import ClimateImpact from "../DetailsSubSections/ClimateChange/ClimateImpact";
import FootInfo from "../ui/FootInfo";
import Magnifier from "../ui/Magnifier";

const ClimateChangeDetail = () => {
  const [showInfo, setShowInfo] = useState(false);
  const [isAutoOpen, setIsAutoOpen] = useState(false);
  const [clickOrigin, setClickOrigin] = useState("center right");
  const aboutIconRef = React.useRef(null);

  useEffect(() => {
    const hasViewed = sessionStorage.getItem("viewed_climate_change_popup");
    if (!hasViewed) {
      if (aboutIconRef.current) {
        const rect = aboutIconRef.current.getBoundingClientRect();
        setClickOrigin(
          `${rect.left + rect.width / 2}px ${rect.top + rect.height / 2}px`,
        );
      }
      setShowInfo(true);
      setIsAutoOpen(true);
      sessionStorage.setItem("viewed_climate_change_popup", "true");
    }
  }, []);

  const handleClose = () => {
    setShowInfo(false);
  };

  const handleExplore = () => {
    setShowInfo(false);
  };

  const handleManualOpen = (e) => {
    if (e && e.currentTarget) {
      const rect = e.currentTarget.getBoundingClientRect();
      setClickOrigin(
        `${rect.left + rect.width / 2}px ${rect.top + rect.height / 2}px`,
      );
    } else {
      setClickOrigin("center right");
    }
    setIsAutoOpen(false);
    setShowInfo(true);
  };

  const scrollToSectionEnd = () => {
    const element = document.getElementById("read-more-section");
    if (element) {
      element.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  };

  return (
    <div className="">
      {/* Infographic Section */}
      <div className="mb-10 lg:mb-36">
        <div className="flex items-center justify-between mt-2 lg:hidden">
          <img
            src="/assets/svgs/countrys.svg"
            alt="Countries"
            className="w-auto h-auto [zoom:0.7]"
          />
          <div className="flex gap-3">
            <button ref={aboutIconRef} onClick={handleManualOpen}>
              <Icon src="/assets/svgs/about.svg" alt="About" />
            </button>
            <button onClick={scrollToSectionEnd}>
              <Icon
                src="/assets/svgs/back_btn.svg"
                alt="Bottom button"
                className="-rotate-90"
              />
            </button>
          </div>
        </div>

        <section className="block lg:hidden">
          <div className="flex items-center justify-center">
            <img
              src="/assets/img/mobile-layout/mobile-climate-change.png"
              alt="Climate change mobile"
            />
          </div>
        </section>

        <section className="relative hidden lg:block">
          <ClimateChangeModel className="[zoom:0.7] xl:[zoom:1]" />
          <div className="absolute top-1/2 -translate-y-1/2 right-5 z-10">
            <div className="flex gap-3">
              <button ref={aboutIconRef} onClick={handleManualOpen}>
                <Icon src="/assets/svgs/about.svg" alt="About" />
              </button>
              <button onClick={scrollToSectionEnd}>
                <Icon
                  src="/assets/svgs/back_btn.svg"
                  alt="Bottom button"
                  className="-rotate-90"
                />
              </button>
            </div>
          </div>
        </section>
      </div>

      <section
        className="grid lg:grid-cols-2 gap-5 scroll-mt-24"
        id="read-more-section"
      >
        <div className="hidden lg:block lg:col-span-1 h-fit sticky top-24 self-start">
          <div className="relative">
            <div className="[zoom:0.6] xl:[zoom:0.75] 2xl:[zoom:0.8]">
              <Magnifier
                zoomScale={3}
                lensSize={180}
                zoomPanelClassName="w-[800px] 1xl:w-[870px] 2xl:w-[1000px] h-[900px]"
              >
                <ClimateChangeModel
                  className="[zoom:0.7] 1xl:[zoom:0.75] 2xl:[zoom:0.8]"
                  showTooltips={false}
                />
              </Magnifier>
            </div>
            <div>
              <div className="absolute left-0 -bottom-32 xl:-bottom-16 [zoom:0.7] xl:[zoom:0.8]">
                {/* Country image at top */}
                <img
                  src="/assets/svgs/countrys.svg"
                  alt="Countries"
                  className="w-auto h-auto"
                />
              </div>
              <div className="absolute -bottom-20 xl:bottom-0 right-5 z-10">
                <Link to="/zoom-in-climate-change">
                  <Icon
                    src="/assets/svgs/zoomIn_btn.svg"
                    alt="Zoom in button"
                  />
                </Link>
              </div>
            </div>
          </div>
        </div>

        <div className="lg:col-span-1">
          <div className="space-y-12">
            <CareSector />
            <CareCrisis />
            <EnvironmentalRelations />
            <ClimateImpact />
            <FootInfo />
          </div>
        </div>
      </section>

      <ClimateChangePopup
        open={showInfo}
        onClose={handleClose}
        onExplore={handleExplore}
        transformOrigin={clickOrigin}
      />
    </div>
  );
};

export default ClimateChangeDetail;
